import { JSX, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ParsedLocation, useRouter } from '@tanstack/react-router';
import { LucideIcon, Rocket } from 'lucide-react';

interface NavSubItem {
  title: string | ReactElement;
  href: ParsedLocation<object>;
}

interface NavItem {
  Icon?: LucideIcon;
  title: string;
  href?: ParsedLocation<object>;
  items?: Array<NavSubItem>;
  action?: ReactElement;
}

export function useConfig(): {
  name: string;
  description: string;
  logo: JSX.Element;
  mainNav: Array<NavItem>;
} {
  const { t } = useTranslation();
  const router = useRouter();

  return {
    name: 'DP World',
    description: '',
    logo: <Rocket className='h-8 w-8 p-2' />,
    mainNav: [
      {
        title: t('navigation.scenarios.title'),
        href: router.buildLocation({
          to: '/app/scenarios',
        }),
        items: [],
      },
    ],
  };
}
